import React, { useEffect, useMemo } from "react";
import { Form } from "react-bootstrap";
import { CardBody } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { renderElement } from "../../../../Components/Common/FormRendererV2/Renderer";
import {
  QuoteDetailsFieldsJSON,
  QuoteEditDetailsFieldsJSON,
} from "../Json/QuoteDetailsFieldsJSON";
import {
  QuoteDetailsLayoutJSON,
  QuoteEditDetailsLayoutJSON,
} from "../Json/QuoteDetailsLayoutJSON";
import { updateRendererState } from "../../../../slices/common/reducer";
import { getUserInfo } from "../../../../Utils/CommonService";
import {
  useQuoteAgOptions,
  useQuoteProductOptions,
} from "../Hook/useQuoteOptions";

function Details() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const editMode = Boolean(id);
  const formState = useSelector((state) => state.common.formRendererState);
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const userInfo = useSelector((state) => state.common.userInfo);

  const { data: agOptions = [] } = useQuoteAgOptions(
    selectedUser.organizationid,
    !editMode
  );
  const { data: productOptions = [] } = useQuoteProductOptions(
    formState.ag_id,
    formState.product_type,
    !editMode
  );

  const layoutJSON = editMode
    ? QuoteEditDetailsLayoutJSON
    : QuoteDetailsLayoutJSON;

  const fieldsJSON = useMemo(() => {
    if (editMode) return QuoteEditDetailsFieldsJSON;
    return {
      ...QuoteDetailsFieldsJSON,
      "1718616984561-customSelect": {
        ...QuoteDetailsFieldsJSON["1718616984561-customSelect"],
        "data-customvalue": agOptions,
      },
      "1718617002793-customSelect": {
        ...QuoteDetailsFieldsJSON["1718617002793-customSelect"],
        "data-customvalue": productOptions,
      },
    };
  }, [editMode, agOptions, productOptions]);

  // Relationship Manager for a new quote is the logged-in user, taken from
  // the "name" field of /product/getUserInfo.
  useEffect(() => {
    if (!editMode && !userInfo?.name) {
      getUserInfo();
    }
  }, [editMode, userInfo?.name]);

  useEffect(() => {
    if (!editMode && userInfo?.name && formState.rm_name !== userInfo.name) {
      dispatch(updateRendererState({ ...formState, rm_name: userInfo.name }));
    }
  }, [editMode, userInfo?.name, formState, dispatch]);

  return (
    <div>
      <Form>
        <CardBody>
          {layoutJSON.map((element) => (
            <div key={element.elementid}>
              {element.child.map((child) =>
                renderElement(child, fieldsJSON, formState)
              )}
            </div>
          ))}
        </CardBody>
      </Form>
    </div>
  );
}

export default Details;
